
import { equals } from "../../fable_modules/fable-library-js.5.13.0/Util.js";
import { convertIntToFastData, emptyFastData } from "../NumberHelpers.js";
import { toFail, printf, toText, join } from "../../fable_modules/fable-library-js.5.13.0/String.js";
import { singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.13.0/Seq.js";
import { toArray, length, cons, iterate, ofArray, empty } from "../../fable_modules/fable-library-js.5.13.0/List.js";
import { isHybridComponent, couldBeSynchronousComponent } from "../SynchronousUtils.js";
import { reverse, item, iterateIndexed, map } from "../../fable_modules/fable-library-js.5.13.0/Array.js";
import { FData, FastSimulation, FastComponent__get_ShortId, FastSimulation__ComponentAt_3B11D6BA } from "../SimTypes.js";
import { instrumentTime, getTimeMs } from "../../Common/TimeHelpers.js";
import { ofMemory } from "../RamStore.js";
import { SimulationComponentState } from "../SimGraphTypes.js";
import { fromZero } from "../../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { fastReduceStep } from "./EvalReference.js";
import { fastReduceFData } from "./EvalAlgebraic.js";

function isValidFData(fd) {
    if (fd.tag === 0) {
        return !equals(fd.fields[0], emptyFastData);
    }
    else {
        return false;
    }
}

function isValidData(fd) {
    return fd.Width !== 0;
}

/**
 * print function for debugging
 */
export function printComp(fs, step, fc) {
    const attr = join("", toList(delay(() => {
        let comp, matchValue;
        return append(((comp = fc, (matchValue = comp.FType, (matchValue.tag === 0) ? (equals(comp.AccessPath, empty()) ? false : (!couldBeSynchronousComponent(matchValue))) : ((matchValue.tag === 42) ? true : (!couldBeSynchronousComponent(matchValue)))))) ? singleton("Co") : singleton("  "), delay(() => append(fc.Touched ? singleton("T") : singleton("U"), delay(() => append(fc.Active ? singleton("Act") : singleton("Inact"), delay(() => append(singleton("    "), delay(() => singleton(join("", map((_arg) => {
            if (_arg) {
                return "*";
            }
            else {
                return "X";
            }
        }, map((arr) => {
            if ((arr.UInt32Slab.length > 0) ? true : (arr.BigIntSlab.length > 0)) {
                return isValidData(arr);
            }
            else {
                return false;
            }
        }, fc.InputLinks))))))))))));
    })));
    const ins = map((option) => {
        let fc_1;
        const option_1 = option;
        if (option_1 != null) {
            return (fc_1 = FastSimulation__ComponentAt_3B11D6BA(fs, option_1[0]), [fc_1.FullName, FastComponent__get_ShortId(fc_1)]);
        }
        else {
            return undefined;
        }
    }, fc.InputDrivers);
    const arg = FastComponent__get_ShortId(fc);
    let arg_3;
    const fc_2 = fc;
    if (((fc_2.NumMissingInputValues === 0) && !fc_2.Touched) && fc_2.Active) {
        const comp_1 = fc_2;
        const matchValue_1 = comp_1.FType;
        let matchResult, ct_2_1;
        switch (matchValue_1.tag) {
            case 0: {
                if (equals(comp_1.AccessPath, empty())) {
                    matchResult = 0;
                }
                else if (couldBeSynchronousComponent(matchValue_1)) {
                    matchResult = 2;
                    ct_2_1 = matchValue_1;
                }
                else {
                    matchResult = 3;
                }
                break;
            }
            case 42: {
                matchResult = 1;
                break;
            }
            default:
                if (couldBeSynchronousComponent(matchValue_1)) {
                    matchResult = 2;
                    ct_2_1 = matchValue_1;
                }
                else {
                    matchResult = 3;
                }
        }
        switch (matchResult) {
            case 0: {
                arg_3 = false;
                break;
            }
            case 1: {
                arg_3 = true;
                break;
            }
            case 2: {
                arg_3 = false;
                break;
            }
            default:
                arg_3 = true;
        }
    }
    else {
        arg_3 = false;
    }
    return toText(printf("%25s %s %15s %A %A"))(arg)(fc.FullName)(attr)(arg_3)(ins);
}

/**
 * Create arrays of components in corrected format for efficient reduction
 * Combinational components are ordered: clokced, constant, global input components are
 * separated.
 */
export function orderCombinationalComponents(numSteps, fs) {
    const startTime = getTimeMs();
    let readyToReduce = empty();
    let orderedComps = ofArray(fs.FConstantComps);
    const propagateEval = (fc) => {
        iterate((fc$0027) => {
            let fc_1, comp, matchValue;
            fc$0027.NumMissingInputValues = ((fc$0027.NumMissingInputValues - 1) | 0);
            if ((fc_1 = fc$0027, (((fc_1.NumMissingInputValues === 0) && !fc_1.Touched) && fc_1.Active) && ((comp = fc_1, (matchValue = comp.FType, (matchValue.tag === 0) ? (equals(comp.AccessPath, empty()) ? false : (!couldBeSynchronousComponent(matchValue))) : ((matchValue.tag === 42) ? true : (!couldBeSynchronousComponent(matchValue)))))))) {
                readyToReduce = cons(fc$0027, readyToReduce);
            }
        }, fc.DrivenComponents);
    };
    fs.FClockedComps.forEach((fc_4) => {
        iterateIndexed((i, vec) => {
            if (!isHybridComponent(fc_4.FType)) {
                fc_4.Touched = true;
                propagateEval(fc_4);
            }
            const matchValue_1 = fc_4.FType;
            const matchValue_2 = item(i, fc_4.Outputs).Width | 0;
            let matchResult, mem, w;
            switch (matchValue_1.tag) {
                case 41: {
                    matchResult = 0;
                    mem = matchValue_1.fields[0];
                    w = matchValue_2;
                    break;
                }
                case 42: {
                    matchResult = 0;
                    mem = matchValue_1.fields[0];
                    w = matchValue_2;
                    break;
                }
                default:
                    matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const matchValue_4 = fc_4.State;
                    if (matchValue_4 != null) {
                        const arr = matchValue_4;
                        arr.Step[0] = (new SimulationComponentState(/* RamState */ 3, [ofMemory(fs.MaxArraySize, mem)]));
                    }
                    else {
                        toFail(printf("Component %s does not have correct state vector"))(fc_4.FullName);
                    }
                    if (vec.Width <= 32) {
                        const this$_1 = vec;
                        this$_1.UInt32Slab[(this$_1.StepBase + 0)] = 0;
                    }
                    else {
                        const dat_2 = fromZero();
                        const this$_2 = vec;
                        this$_2.BigIntSlab[(this$_2.StepBase + 0)] = dat_2;
                    }
                    break;
                }
                case 1: {
                    if (vec.Width <= 32) {
                        const this$_3 = vec;
                        this$_3.UInt32Slab[(this$_3.StepBase + 0)] = 0;
                    }
                    else {
                        const dat_6 = fromZero();
                        const this$_4 = vec;
                        this$_4.BigIntSlab[(this$_4.StepBase + 0)] = dat_6;
                    }
                    break;
                }
            }
        }, fc_4.Outputs);
    });
    fs.FConstantComps.forEach((fc_2) => {
        fastReduceStep(1, 0, false, fc_2);
        fc_2.Touched = true;
        propagateEval(fc_2);
    });
    fs.FGlobalInputComps.forEach((fc_3) => {
        fastReduceStep(fs.MaxArraySize, 0, false, fc_3);
        fc_3.Touched = true;
        propagateEval(fc_3);
    });
    while (length(readyToReduce) !== 0) {
        const readyL = readyToReduce;
        readyToReduce = empty();
        iterate((fc_5) => {
            fastReduceStep(fs.MaxArraySize, 0, false, fc_5);
            orderedComps = cons(fc_5, orderedComps);
            fc_5.Touched = true;
            propagateEval(fc_5);
        }, readyL);
    }
    instrumentTime("orderCombinationalComponents", startTime);
    const FOrderedComps = reverse(toArray(orderedComps));
    return new FastSimulation(fs.ClockTick, fs.MaxArraySize, fs.FGlobalInputComps, fs.FConstantComps, fs.FClockedComps, FOrderedComps, fs.FIOActive, fs.FIOLinks, fs.FCompsByIndex, fs.FIndexOf, fs.FCustomOutputCompLookup, fs.NumStepArrays, fs.Drivers, fs.WaveIndex, fs.Design, fs.StepCost);
}

export function orderCombinationalComponentsFData(numSteps, fs) {
    const startTime = getTimeMs();
    let readyToReduce = empty();
    let orderedComps = ofArray(fs.FConstantComps);
    const propagateEval = (fc) => {
        iterate((fc$0027) => {
            let fc_1, comp, matchValue;
            fc$0027.NumMissingInputValues = ((fc$0027.NumMissingInputValues - 1) | 0);
            if ((fc_1 = fc$0027, (((fc_1.NumMissingInputValues === 0) && !fc_1.Touched) && fc_1.Active) && ((comp = fc_1, (matchValue = comp.FType, (matchValue.tag === 0) ? (equals(comp.AccessPath, empty()) ? false : (!couldBeSynchronousComponent(matchValue))) : ((matchValue.tag === 42) ? true : (!couldBeSynchronousComponent(matchValue)))))))) {
                readyToReduce = cons(fc$0027, readyToReduce);
            }
        }, fc.DrivenComponents);
    };
    fs.FClockedComps.forEach((fc_4) => {
        iterateIndexed((i_1, vec) => {
            if (!isHybridComponent(fc_4.FType)) {
                fc_4.Touched = true;
                propagateEval(fc_4);
            }
            const matchValue_1 = fc_4.FType;
            const matchValue_2 = item(i_1, fc_4.Outputs).Width | 0;
            let matchResult, mem, w;
            switch (matchValue_1.tag) {
                case 41: {
                    matchResult = 0;
                    mem = matchValue_1.fields[0];
                    w = matchValue_2;
                    break;
                }
                case 42: {
                    matchResult = 0;
                    mem = matchValue_1.fields[0];
                    w = matchValue_2;
                    break;
                }
                default:
                    matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const matchValue_4 = fc_4.State;
                    if (matchValue_4 != null) {
                        const arr = matchValue_4;
                        arr.Step[0] = (new SimulationComponentState(/* RamState */ 3, [ofMemory(fs.MaxArraySize, mem)]));
                    }
                    else {
                        toFail(printf("Component %s does not have correct state vector"))(fc_4.FullName);
                    }
                    vec.FDataStep[0] = (new FData(/* Data */ 0, [convertIntToFastData(w, 0)]));
                    break;
                }
                case 1: {
                    vec.FDataStep[0] = (new FData(/* Data */ 0, [convertIntToFastData(matchValue_2, 0)]));
                    break;
                }
            }
        }, fc_4.Outputs);
    });
    fs.FConstantComps.forEach((fc_2) => {
        fastReduceFData(0, 0, false, fc_2);
        fc_2.Touched = true;
        propagateEval(fc_2);
    });
    fs.FGlobalInputComps.forEach((fc_3) => {
        iterateIndexed((i, _arg) => {
            item(0, fc_3.InputLinks).FDataStep[i] = (new FData(/* Data */ 0, [convertIntToFastData(item(0, fc_3.Outputs).Width, 0)]));
        }, item(0, fc_3.InputLinks).FDataStep);
        fastReduceFData(fs.MaxArraySize, 0, false, fc_3);
        fc_3.Touched = true;
        propagateEval(fc_3);
    });
    while (length(readyToReduce) !== 0) {
        const readyL = readyToReduce;
        readyToReduce = empty();
        iterate((fc_5) => {
            fastReduceFData(fs.MaxArraySize, 0, false, fc_5);
            orderedComps = cons(fc_5, orderedComps);
            fc_5.Touched = true;
            propagateEval(fc_5);
        }, readyL);
    }
    instrumentTime("orderCombinationalComponents", startTime);
    const FOrderedComps = reverse(toArray(orderedComps));
    return new FastSimulation(fs.ClockTick, fs.MaxArraySize, fs.FGlobalInputComps, fs.FConstantComps, fs.FClockedComps, FOrderedComps, fs.FIOActive, fs.FIOLinks, fs.FCompsByIndex, fs.FIndexOf, fs.FCustomOutputCompLookup, fs.NumStepArrays, fs.Drivers, fs.WaveIndex, fs.Design, fs.StepCost);
}

